<script>
import Portfolio from './Portfolio.svelte';	
import Bio from './Bio.svelte';	

let width;
let isMobile = false;
$: isMobile = width <= 600;

</script>

<style>
.app {
	margin: 0px auto;
	max-width: 550px;
	max-width: 60ch;
	font-size: 20px;
	padding: 8px;
}

:global(.clear) {
	clear: both;
}

:global(.no-wrap) {
	white-space: nowrap;
}
</style>

<div class="app" bind:clientWidth={width}>
	<Bio isMobile={isMobile} />
	<Portfolio isMobile={isMobile} />
</div>